import React, { useEffect, useState } from "react";
import api, { formatTL, formatDuration, formatDateTime } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Plate } from "@/components/Plate";

export default function CustomerHistory() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/customer/sessions");
      setSessions(data.filter((s) => s.status === "closed"));
    })();
  }, []);

  return (
    <div className="space-y-4 animate-fade-in">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Geçmiş</div>
        <h1 className="text-3xl font-bold tracking-tight">Oturumlarım</h1>
      </div>

      <div className="space-y-3">
        {sessions.length === 0 && <Card className="rounded-sm border-border"><CardContent className="p-8 text-center text-muted-foreground text-sm">Henüz kapanmış oturum yok</CardContent></Card>}
        {sessions.map((s) => (
          <Card key={s.id} className="rounded-sm border-border">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <Plate country={s.country_code}>{s.plate}</Plate>
                <Badge
                  variant={s.payment_status === "odendi" ? "outline" : s.payment_status === "muaf" ? "outline" : "destructive"}
                  className="rounded-sm uppercase text-[10px] tracking-widest"
                >
                  {s.payment_status}
                </Badge>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs mt-3">
                <div>
                  <div className="text-muted-foreground uppercase tracking-widest">Giriş</div>
                  <div>{formatDateTime(s.entry_time)}</div>
                </div>
                <div>
                  <div className="text-muted-foreground uppercase tracking-widest">Çıkış</div>
                  <div>{formatDateTime(s.exit_time)}</div>
                </div>
                <div>
                  <div className="text-muted-foreground uppercase tracking-widest">Süre</div>
                  <div className="font-mono">{formatDuration(s.duration_minutes)}</div>
                </div>
                <div>
                  <div className="text-muted-foreground uppercase tracking-widest">Ücret</div>
                  <div className="font-mono font-bold">{formatTL(s.fee)}</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
